import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/access";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import { Suspense } from "react";

export default function RegisterAccessView({
  goBack,
  isDisabled,
  goToLogin,
  validatesPassword,
  validatesConfirmPassword,
  isVisiblePassword,
  isVisibleConfirmPassword,
  toggleIsVisiblePassword,
  toggleIsVisibleConfirmPassword,
  isLoading,
  error,
  errorPlate,
  success,
  register,
  handleSubmit,
  isVisibleModal,
  toggleModal,
}: PropsView) {
  return (
    <div className="h-full">
      {!success && <Header
        title="Senha"
        hasLeftButton
        goBack={goBack}
      />}
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          {!success && <div>
            <h2 className="mt-6 text-black text-xl">Dados de acesso</h2>
            <h3 className="text-black text-sm">Informe seus dados nos campos abaixo</h3>
            <div className="flex flex-col justify-center items-center">
              <div className="flex flex-col w-full mt-3 relative">
                <input
                  {...register("password")}
                  required
                  type={isVisiblePassword ? "text" : "password"}
                  name="password"
                  placeholder="Sua senha"
                  className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <button type="button" onClick={toggleIsVisiblePassword} className="absolute right-2 top-5">
                  <img 
                    src={isVisiblePassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="mt-1 bg-white w-full rounded-md p-2">
                {validatesPassword?.map((item, index) => (
                  <div key={index} className="flex flex-row items-center justify-start">
                    <img 
                      src={item.success ? "/icon-checked.png" : "/icon-unchecked.png"}
                      width={16}
                      height={16}
                      alt="ícone sucesso"
                      className="mr-2"
                    />
                    <p className="text-sm text-gray-400">{item.text}</p>
                  </div>
                ))}
              </div>
              <div className="flex flex-col w-full mt-3 relative">
                <input
                  {...register("confirmPassword")}
                  required
                  type={isVisibleConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirmar senha"
                  className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <button type="button" onClick={toggleIsVisibleConfirmPassword} className="absolute right-2 top-5">
                  <img 
                    src={isVisibleConfirmPassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="mt-1 bg-white w-full rounded-md p-2">
                {validatesConfirmPassword?.map((item, index) => (
                  <div key={index} className="flex flex-row items-center justify-start">
                    <img 
                      src={item.success ? "/icon-checked.png" : "/icon-unchecked.png"}
                      width={16}
                      height={16}
                      alt="ícone sucesso"
                      className="mr-2"
                    />
                    <p className="text-sm text-gray-400">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>}
          {success && <div className="w-full h-full flex flex-col items-center justify-center">
            <img 
              src={"/icon-checked.png"}
              width={86}
              height={86}
              alt="ícone sucesso"
              className="mr-2"
            />
            <h1 className="mt-6 text-black font-bold text-xl">Cadastro concluído!</h1>
            <h2 className="mt-2 text-gray-500 text-xl text-center">Agora você pode aproveitar a praticidade do Pedágio Eletrônico Sem Parar.</h2>
          </div>}
          {!success && <Button 
            title={"Avançar"}
            type="submit"
            isDisabled={isDisabled}
          />}
          {success && <div className="w-full flex flex-col">
            <p className="text-sm text-gray-500 text-center mb-4"><strong>Evite imprevistos:</strong> fique de olho na validade do cartão e atualize se necessário.</p>
            <Button 
              title={"Acessar conta"}
              onClick={goToLogin}
              type="button"
              isDisabled={false}
            />
          </div>}
        </form>
      </main>
      {error && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Houve um problema ao registrar tuas informações, quer tentar novamente?"
          actionMessage="Tentar novamente"
          action={() => {
            toggleModal();
            handleSubmit();
          }}
          actionSecondMessage="Não!"
          actionSecond={toggleModal}
        />
      </Suspense> }
      {errorPlate && isVisibleModal && <Suspense fallback={null}> 
        <Modal
          title="Ops!"
          message="Esta placa já está cadastrada. Realize o login para acessar as transações."
          actionMessage="Ok!"
          action={toggleModal}
        />
      </Suspense>}
      {isLoading && <Loading />}
    </div>
  );
}
